import { render, staticRenderFns } from "./ModalOrderPreparationDetail.vue?vue&type=template&id=58dd2f47&scoped=true&"
import script from "./ModalOrderPreparationDetail.vue?vue&type=script&lang=ts&"
export * from "./ModalOrderPreparationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ModalOrderPreparationDetail.vue?vue&type=style&index=0&id=58dd2f47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd2f47",
  null
  
)

export default component.exports